/**
 * summary — «Сводка»: свободный текст резюме + структурированная СЦР
 * (Ситуация / Действия / Результат). Зеркалит SummarySection.tsx: те же два
 * источника (textSummary, structuredSummary), тот же порядок, ключи
 * `records.analysisPanel.situation` / `.actions` / `.outcome` — НЕ
 * `analysisPanel.structuredSummary.*`, как написано в тексте брифа. Экран
 * прав: `structuredSummary.*` — устаревшие ключи первой версии панели,
 * v2-компонент их не читает.
 */
import { card, block } from '../primitives';
import { escapeHtml } from '../escape';
import type { SectionFn } from '../types';

export const renderSummary: SectionFn = (input, t) => {
  const { result } = input.analysis;
  const sao = result.structuredSummary;

  if (!result.textSummary && !sao) return '';

  const textSummaryHtml = result.textSummary
    ? `<div class="blk"><p>${escapeHtml(result.textSummary)}</p></div>`
    : '';

  const situationHtml = sao?.situation
    ? block(t('records.analysisPanel.situation'), `<p>${escapeHtml(sao.situation)}</p>`)
    : '';

  const actionsHtml =
    sao?.actions && sao.actions.length > 0
      ? block(
          t('records.analysisPanel.actions'),
          `<ul>${sao.actions.map((a) => `<li>${escapeHtml(a)}</li>`).join('')}</ul>`
        )
      : '';

  const outcomeHtml = sao?.outcome
    ? block(t('records.analysisPanel.outcome'), `<p>${escapeHtml(sao.outcome)}</p>`)
    : '';

  return card({
    title: t('records.analysisPanel.summary.title'),
    body: textSummaryHtml + situationHtml + actionsHtml + outcomeHtml,
  });
};
